<template>
    <div :class="{promoSpot: promoSpot}" class="containerWrapper">
        <!-- 1. add render component here for each type, setting dataSet to key of section -->
        <main-hero :assetHost="assetHost" :item="promoData" :menuList="menuList" v-if="dataSet === 'mainHero'"></main-hero>
        <promo-spot :assetHost="assetHost" :item="promoData" v-if="dataSet === 'promos'"></promo-spot>
        <promo-banner :assetHost="assetHost" :item="promoData" v-if="dataSet === 'promoBanner'"></promo-banner>
        <lightbox  :assetHost="assetHost" :item="promoData" :displayedCount="displayedCount" v-on:incrementDisplayCount="incrementDisplayCount" v-if="selector === 'lightbox'"/>
    </div>
</template>

<script>
    // 2. import cms render-components here
    import CmsMainMenu from '../components/cms/CmsRenderHeaderMenu.vue';
    import MainHero from '../components/cms/MainHero.vue';
    import PromoSpot from '../components/cms/PromoSpot.vue';
    import PromoBanner from '../components/cms/PromoBanner.vue';
    import CmsFooterMenu from '../components/cms/CmsRenderFooterMenu.vue';
    import Lightbox from '../components/cms/Lightbox.vue';
    import Cookies from '../utils/cookies.js';
    export default {
    // 3. add imported components
    components: {
      CmsMainMenu,
      MainHero,
      PromoSpot,
      PromoBanner,
      CmsFooterMenu,
      Lightbox,
      Cookies
    },
    computed: {
      cmsData() {
        return this.$store.state.cms[this.dataSet];
      },
      promoData() {
        return this.$store.state.cms.promos[this.selector];
      },
      menuList() {
        if (typeof this.$store.state.cms.heroMenu[0] === 'object') {
          return this.$store.state.cms.heroMenu[0].linkList || [];
        } else {
          return [];
        }
      },
      promoSpot() {
        return (this.dataSet === 'promos') ? 'promoSpot' : '';
      },
      menuState() {
        return this.$store.state.mainMenuState;
      },
      cookieName(){
        if(this.promoData && this.promoData.hasOwnProperty('id')) {
          return 'ckPopCount-' + this.promoData.id;
        }
      },
      displayedCount() {
        return  parseInt(Cookies.get(this.cookieName)) || 0;
      }
    },
    props: {
      dataSet: {
        default: '',
        type: String,
      },
      selector: {
        default: '',
        type: String,
      },
    },
    data() {
      return {
        assetHost: this.$store.state.assetHost,
      };
    },
    methods: {
      updateMenuState(state) {
        let key;
        for (key in state) {
          this.$store.commit(key, state[key]);
        }
      },
      incrementDisplayCount(){
        Cookies.set(this.cookieName, (this.displayedCount+1), 365);
      }
    },
  };
</script>
